<aside class="sidebar">
  <header class="shadow-sm">
    <h4 [translate]="Localization.Contacts"
        class="title"></h4>
    <i class="fa fa-search"></i>
    <input [formControl]="searchField"
           class="form-control"
           type="search"/>
    <a (click)="createContact()"
       class="btn-floating"
       role="button">
      <i class="fa fa-plus"></i>
    </a>
  </header>

  <section class="contacts">
    <mdb-progress-bar *ngIf="loading"
                      mode="indeterminate"></mdb-progress-bar>
    <ol class="scroll-view contact-list">
      <li (click)="browse(contact)"
          *ngFor="let contact of filteredContacts"
          [class.active]="contact.id === selectedContact?.id"
          class="clickable">
        {{ contact.firstName }} {{ contact.lastName}}
      </li>
    </ol>
  </section>
</aside>
<main class="content">
  <div class="scroll-view">
    <app-contact-details (onContactDeleted)="didDeleted($event)"
                         [contact]="selectedContact"></app-contact-details>
  </div>
</main>
